import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvConfig, EnvironnementManager } from '@wizeoo/akm-common-lib';
import { KeycloakService } from 'keycloak-angular';
import { catchError, Observable, of, throwError } from 'rxjs';
import { Model } from './../../model/model';


@Injectable()
export class APIHttpInterceptor implements HttpInterceptor {
  constructor(private keycloak: KeycloakService) { }

  private get envConfig(): EnvConfig {
    let env: EnvConfig = EnvironnementManager.envConfig;
    // console.log(' EnvironnementManager APIHttpInterceptor', env)
    return env;
  }

  private get baseUrl(): string {
    return this.envConfig.apiUrl;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // TODO A revoir
    // Si on ne vient pas d'un appel pour le batch, on construit la requête "normalement"
    // console.log('httpIntercept', req.url);
    if (req.url.indexOf('http') === -1) {
      let url: string = `${this.baseUrl}/${req.url}`;

      let targetApi: string = this.baseUrl + '/';
      if (req.url.indexOf(this.envConfig.batchUrl) >= 0
        || req.url.indexOf(this.envConfig.connectUrl) >= 0
        || req.url.indexOf(this.envConfig.computeUrl) >= 0) { // neutralisation pour les appels batch, connect et compute
        targetApi = '';
      }

      if (req.url.indexOf(this.envConfig.specifUrl["base"]) >= 0) { // neutralisation pour les appels spécifiques
        targetApi = '';
      }      

      // suppression des ports...
      const goodLocation = window.location.host.split(':')[0];
      url = `${window.location.protocol}//${goodLocation}${targetApi}${req.url}`;


      let headers: HttpHeaders = req.headers;

      headers = headers.append('timeout', '3600');

      if (Model.getInstance().domainCode) {
        headers = headers.append('X-criteria-domain', Model.getInstance().domainCode);
      }

      if (Model.getInstance().businessUnitCode) {
        headers = headers.append('X-criteria-bu', Model.getInstance().businessUnitCode);
      }

      const apiReq = req.clone({ url, headers });
      // console.log('clean url', url, headers);

      /*return next.handle(apiReq)
      .pipe(map((event: HttpEvent<any>) => this.handleSuccess(event, next, apiReq)))
      .pipe(catchError(err => this.handleError(err, next, apiReq)));*/

      return next.handle(apiReq).pipe(catchError((err: HttpErrorResponse) => this.handleError(err, next, apiReq)));
    } else {
      // Passe jamais ici...
      // TODO ici, isolation des batchs... timeOut ?
      // Sinon on passe la requête fournie pour l'appel de batch
      let url: string = req.url;
      let headers: HttpHeaders = req.headers;

      // headers = headers.append('timeout', '3600');

      if (Model.getInstance().domainCode) {
        headers = headers.append('X-criteria-domain', Model.getInstance().domainCode);
      }

      if (Model.getInstance().businessUnitCode) {
        headers = headers.append('X-criteria-bu', Model.getInstance().businessUnitCode);
      }
      const apiReq = req.clone({ url, headers });
      return next.handle(apiReq);

    }
  }

  private handleError(err: HttpErrorResponse, next: HttpHandler, request: HttpRequest<any>): Observable<any> {
    // console.log('httpInterceptError', err, request);

    if (err.status === HttpStatusCode.Forbidden || err.status === HttpStatusCode.Unauthorized) {
      return of(this.keycloak.updateToken()
        .then((success) => {
          if (success) {
            next.handle(request);
          } else {
            // On a eu une erreur 401 ou 403 et on n'a pas réussi à rafraichir le token
            // On redirige vers la page de login
            this.keycloak.login({ redirectUri: window.location.href });
          }
        })
        .catch(_ => this.keycloak.login({ redirectUri: window.location.href })));
    }

    return throwError(() => err);
  }
}
